import { render, staticRenderFns } from "./InfoPedido.vue?vue&type=template&id=29264661&scoped=true"
import script from "./InfoPedido.vue?vue&type=script&lang=js"
export * from "./InfoPedido.vue?vue&type=script&lang=js"
import style0 from "./InfoPedido.vue?vue&type=style&index=0&id=29264661&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29264661",
  null
  
)

export default component.exports